// extracted by mini-css-extract-plugin
export default {"hover-only":"_1__6W","hoverOnly":"_1__6W","hover-only-and-collapsed":"ZzY8k","hoverOnlyAndCollapsed":"ZzY8k","hoverable":"_3cLdn","permanent-icon":"wM0RZ","permanentIcon":"wM0RZ"};